/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import "./src/css/custom.scss";

export const shouldUpdateScroll = ({ prevRouterProps, routerProps }) => {
  // Se non sto cambiando pagina non aggiornare la scroll position
  if (
    prevRouterProps?.location?.pathname === routerProps?.location?.pathname &&
    !routerProps?.location?.hash
  ) {
    return false;
  }
};
